import { gql } from "@apollo/client";

export const GET_STUDENT = gql`
  query getStudent($id: ID!) {
    student(id: $id) {
      id
      teacher_id
      name
      first_name
      last_name
      login_code
      class_id
      last_login
      lang_id
      created
      first_visit
      minutes
      firebase_id
      semester_minutes
      class {
        id
        name
      }
      history {
        chapter
        chapter_last
        read_time
        start_time
        last_time
        score
        allow_retake
        rating {
          value
          opinion
          date
        }
        book {
          id
          title
          url
          is_author
          chapters
          is_author
        }
      }
    }
    languages {
      id
      name
    }
    classes {
      value: id
      txt: name
    }
  }
`;

export const GETRESPONSES = gql`
  query getResponses($book_id: ID!, $student_id: ID!, $is_creator: Boolean!) {
    bookQuestions(
      book_id: $book_id
      student_id: $student_id
      is_creator: $is_creator
    ) {
      id
      chapter
      question
      success_meme
      success_msg
      requested_retake
      fail_msg
      fail_meme
      response
      correct
      updated
      timestamp
      tries
      options {
        id
        question_id
        option_txt
        accepted
      }
    }
  }
`;

export const GET_GRADES = gql`
  query getGrades($student_id: ID) {
    grades(student_id: $student_id, all: true) {
      student {
        id
        created
        name
        login_code
        class_id
        minutes
        semester_minutes
        last_login
        class {
          name
        }
        history {
          score
          allow_retake
          request_retake
        }
      }
      book {
        title
        id
        chapters
        chapter_questions
        is_author
      }
      grades {
        chapter
        grade
        question_num
        requested_retake
        past
      }
      overall {
        grade
        question_num
      }
    }
    authorGrades: grades(student_id: $student_id, is_creator: true) {
      student {
        id
        created
        name
        login_code
        class_id
        minutes
        semester_minutes
        last_login
        class {
          name
        }
        history {
          score
          allow_retake
          request_retake
        }
      }
      book {
        title
        id
        chapters
        chapter_questions
        is_author
      }
      grades {
        chapter
        grade
        question_num
        requested_retake
      }
      overall {
        grade
        question_num
      }
    }
  }
`;

export const UPDATE_STUDENT = gql`
  mutation updateStudent(
    $id: ID!
    $first_name: String!
    $firebase_token: String
    $last_name: String!
    $class_id: ID!
    $password: String
    $lang_id: ID
  ) {
    student(
      id: $id
      first_name: $first_name
      firebase_token: $firebase_token
      last_name: $last_name
      class_id: $class_id
      password: $password
      lang_id: $lang_id
    ) {
      id
    }
  }
`;

export const REMOVE_STUDENT = gql`
  mutation deleteStudents($ids: [ID]!) {
    studentsRemove(ids: $ids)
  }
`;
